import * as mathjs from "mathjs";

import { findClosestNote } from "@/lib/key";
import { Marker } from "@/types/defs/pitchCorrection/marker";

export const calculatePitchMapping = (
  keyz: number[],
  circles: Marker[],
  knobPitchPitchListReference: number[]
) => {
  const segments_: number[][] = [[]];

  let pitchIx = 0;
  let circleIx = 0;

  while (true) {
    if (circleIx >= circles.length) {
      break;
    }
    let changedCircleIx = false;
    const isTerminalEndpointOnRight =
      circleIx < circles.length &&
      circles[circleIx].isEndpoint === true &&
      (circleIx === circles.length - 1 ||
        knobPitchPitchListReference[circles[circleIx].index + 1] === 0);

    while (
      circleIx < circles.length &&
      (isTerminalEndpointOnRight ?
        circles[circleIx].index < pitchIx
      : circles[circleIx].index <= pitchIx)
    ) {
      circleIx++;
      changedCircleIx = true;
    }

    if (changedCircleIx && segments_[segments_.length - 1].length !== 0) {
      segments_.push([]);
    }

    segments_[segments_.length - 1].push(knobPitchPitchListReference[pitchIx]);
    pitchIx++;
    if (pitchIx >= knobPitchPitchListReference.length) {
      break;
    }
  }

  while (pitchIx < knobPitchPitchListReference.length) {
    if (segments_[segments_.length - 1].length !== 0) {
      segments_.push([]);
    }
    segments_[segments_.length - 1].push(knobPitchPitchListReference[pitchIx]);
    pitchIx++;
  }

  const segments = segments_.filter((s) => s.length > 0);

  const medians = segments.map((v) => {
    return mathjs.median([...v].sort());
  });

  const targets = medians.map((v) => (v === 0 ? 0 : findClosestNote(keyz, v)));

  const newPitches = segments
    .map((s, i) => s.map((x) => (x === 0 ? 0 : targets[i])))
    .flat();
  return newPitches;
};
